import { ref, update, get } from "firebase/database";
import { auth, db } from "../../config/firebase";
import { uploadFileArraysToStorage } from './uploadFileArraysToStorage';


const saveResultsToFirebase = async (configId, results, setProgress, skipStorage = false) => {
  const user = auth.currentUser;
  if (!user || !configId) return;

  const fileTypes = ['stdFiles', 'qcFiles', 'unkFiles'];
  let totalUploads = 0;
  let completedUploads = 0;
  if (!skipStorage) {
    for (const fileType of fileTypes) {
      const filesObj = results[fileType];
      if (filesObj && typeof filesObj === 'object') {
        totalUploads += Object.keys(filesObj).length * 3; // 3 arrays per file
      }
    }
    if (totalUploads === 0 && setProgress) setProgress(100);
  }

  // Helper to process files for a given fileType
  async function processFiles(fileType, dbFiles = {}) {
    const filesObj = results[fileType];
    if (!filesObj || typeof filesObj !== 'object') return {};
    const processed = {};
    for (const [fileName, fileObj] of Object.entries(filesObj)) {
      if (!skipStorage) {
        // Upload only originalData to storage and get URL, with progress
        const urls = await uploadFileArraysToStorage(user.uid, configId, fileType, fileName, fileObj, () => {
          completedUploads++;
          if (setProgress) setProgress(Math.round((completedUploads / totalUploads) * 100));
        });
        // Remove large arrays from fileObj
        const { originalData, originalXValues, originalYValues, ...rest } = fileObj;
        processed[fileName] = {
          ...rest,
          ...(urls.originalDataUrl && { originalDataUrl: urls.originalDataUrl })
        };
      } else {
        // Merge DB file object (for URLs) with Redux file object (for new data)
        const dbFile = dbFiles[fileName] || {};
        const { originalData, originalXValues, originalYValues, ...reduxRest } = fileObj;
        processed[fileName] = {
          ...dbFile, // includes URLs
          ...reduxRest // overwrites with new Redux data
        };
      }
    }
    return processed;
  }

  let dbFilesByType = {};
  if (skipStorage) {
    // Fetch current DB file objects for merging URLs
    const resultsRef = ref(db, `users/${user.uid}/results/${configId}`);
    const snapshot = await get(resultsRef);
    const dbData = snapshot.exists() ? snapshot.val() : {};
    for (const fileType of fileTypes) {
      dbFilesByType[fileType] = dbData[fileType] || {};
    }
  }

  // Process all file types
  const stdFiles = await processFiles('stdFiles', dbFilesByType['stdFiles']);
  const qcFiles = await processFiles('qcFiles', dbFilesByType['qcFiles']);
  const unkFiles = await processFiles('unkFiles', dbFilesByType['unkFiles']);

  const resultsRef = ref(db, `users/${user.uid}/results/${configId}`);

  await update(resultsRef, {
    ...results,
    stdFiles,
    qcFiles,
    unkFiles,
    lastUpdated: Date.now()
  });
  if (setProgress) setProgress(100);
};

export default saveResultsToFirebase;